if (!customElements.get("sq-short-description")) {
  class SQShortDescription extends HTMLElement {
    constructor() {
      super();
      this.contentEl = this.querySelector('[data-short-description-content]');
      
      document.addEventListener("variant:changed", (event) => {
        if (event) {
          this.updateShortDescription(event);
        }
      });
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.updateShortDescription();
    }

    updateShortDescription(event) {
      const dataEl = document.getElementById("sq_short_description_data");
      if (!dataEl) return;

      this.sqData = JSON.parse(dataEl.textContent);
      
      let variantId;
      if (!event) {
        const variantInput = document.getElementById("sq-variant-id");
        variantId = variantInput ? variantInput.value : null;
      } else {
        variantId = event.detail.variant.id;
      }

      if (!variantId) return;

      const variantData = this.sqData.variants.find(
        item => item.id.toString() === variantId.toString()
      );

      let shortDesc = "";

      // Variant Short Description 우선
      if (variantData && variantData.short_description) {
        shortDesc = variantData.short_description;
      } 
      // Fallback: Product Short Description
      else if (this.sqData.product_short_description) {
        shortDesc = this.sqData.product_short_description;
      }

      // 콘텐츠 업데이트
      if (this.contentEl) {
        if (shortDesc) {
          this.contentEl.innerHTML = shortDesc;
          this.style.display = "block";
        } else {
          this.contentEl.innerHTML = "";
          this.style.display = "none";
        }
      }
    }
  }

  customElements.define("sq-short-description", SQShortDescription);
}